// Specific Heat Capacity units with conversion factors to J/(kg·K)
export const specificHeatCapacityUnits = [
  { id: 'joule-per-kilogram-kelvin', name: 'Joule per Kilogram Kelvin', symbol: 'J/(kg·K)', plural: 'Joules per Kilogram Kelvin', factor: 1 },
  { id: 'joule-per-kilogram-celsius', name: 'Joule per Kilogram Celsius', symbol: 'J/(kg·°C)', plural: 'Joules per Kilogram Celsius', factor: 1 },
  { id: 'joule-per-gram-celsius', name: 'Joule per Gram Celsius', symbol: 'J/(g·°C)', plural: 'Joules per Gram Celsius', factor: 1000 },
  { id: 'kilojoule-per-kilogram-kelvin', name: 'Kilojoule per Kilogram Kelvin', symbol: 'kJ/(kg·K)', plural: 'Kilojoules per Kilogram Kelvin', factor: 1000 },
  { id: 'kilojoule-per-kilogram-celsius', name: 'Kilojoule per Kilogram Celsius', symbol: 'kJ/(kg·°C)', plural: 'Kilojoules per Kilogram Celsius', factor: 1000 },
  { id: 'calorie-per-gram-celsius', name: 'Calorie per Gram Celsius', symbol: 'cal/(g·°C)', plural: 'Calories per Gram Celsius', factor: 4184 },
  { id: 'kilocalorie-per-kilogram-celsius', name: 'Kilocalorie per Kilogram Celsius', symbol: 'kcal/(kg·°C)', plural: 'Kilocalories per Kilogram Celsius', factor: 4184 },
  { id: 'btu-per-pound-fahrenheit', name: 'BTU per Pound Fahrenheit', symbol: 'BTU/(lb·°F)', plural: 'BTUs per Pound Fahrenheit', factor: 4186.8 },
  { id: 'btu-per-pound-rankine', name: 'BTU per Pound Rankine', symbol: 'BTU/(lb·°R)', plural: 'BTUs per Pound Rankine', factor: 4186.8 },
];

export const popularSpecificHeatCapacityConversions = [
  { from: 'joule-per-kilogram-kelvin', to: 'kilojoule-per-kilogram-kelvin' },
  { from: 'kilojoule-per-kilogram-kelvin', to: 'joule-per-kilogram-kelvin' },
  { from: 'joule-per-kilogram-kelvin', to: 'calorie-per-gram-celsius' },
  { from: 'calorie-per-gram-celsius', to: 'joule-per-kilogram-kelvin' },
  { from: 'joule-per-kilogram-kelvin', to: 'btu-per-pound-fahrenheit' },
  { from: 'btu-per-pound-fahrenheit', to: 'joule-per-kilogram-kelvin' },
];

export const getUnitById = (id) => specificHeatCapacityUnits.find(unit => unit.id === id);

export const convertSpecificHeatCapacity = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert specific heat capacity units and learn the conversion formula.`;
};
